module.exports = __webpack_public_path__ + "static/img/h5-11.be30784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-11.png
// module id = UjW9
// module chunks = 1